import { useState } from "react";
import Header from "@/components/store/Header";
import CartSheet from "@/components/store/CartSheet";
import Hero from "@/components/store/Hero";
import Categories from "@/components/store/Categories";
import Catalog from "@/components/store/Catalog";
import { Gallery, Services, HowItWorks, Faq } from "@/components/store/Sections";
import Reviews from "@/components/store/Reviews";
import Checkout from "@/components/store/Checkout";
import StoreInfo from "@/components/store/StoreInfo";
import Footer from "@/components/store/Footer";
import WhatsAppFloat from "@/components/store/WhatsAppFloat";

export default function Storefront() {
  const [filter, setFilter] = useState("semua");

  return (
    <div data-testid="storefront" className="bg-[#FBF9F5] text-[#2C332A] antialiased">
      <Header />
      <main>
        <Hero />
        <Categories onSelect={setFilter} />
        <Catalog filter={filter} setFilter={setFilter} />
        <Gallery />
        <Services />
        <HowItWorks />
        <Reviews />
        <Faq />
        <Checkout />
        <StoreInfo />
      </main>
      <Footer />
      <CartSheet />
      <WhatsAppFloat />
    </div>
  );
}
